﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const OperationalContextClient_1 = require("./swagger/OperationalContextClient");
class InjectionPointClient {
    constructor(baseURL) {
        if (baseURL) {
            this.client = new OperationalContextClient_1.OperationalContextClient(baseURL);
        }
        else {
            this.client = new OperationalContextClient_1.OperationalContextClient();
        }
    }
    getInjectionPoints() {
        return this.client.apiInjectionpointInterceptorsGet();
    }
    enableDisableInterceptor(injectionPointId, interceptorId, value) {
        return this.client.apiInjectionpointByIdInjectionPointInterceptorsByIdInterceptorActivateByValuePost(injectionPointId, interceptorId, value);
    }
}
exports.InjectionPointClient = InjectionPointClient;
//# sourceMappingURL=InjectionPointClient.js.map